<template>
    <div class="dialog-advanced-filter" v-if="show">
        <div class="dialog-advanced-filter__header">
            <span class="dialog-advanced-filter__title">
                {{ translate('btn_advanced_filters') }}
            </span>
            <div class="dialog-advanced-filter__action">
                <el-link v-if="hasFilters" @click="clearFilters()">
                    {{ translate('clear_filters') }}
                </el-link>
                <el-link @click="$emit('handleFilter', filterData)">
                    {{ translate('apply_filters') }}
                </el-link>
            </div>
        </div>
        <div class="dialog-advanced-filter__content">
            <el-form>
                <el-collapse v-model="collapseSelected">
                    <el-collapse-item
                        :title="translate('operation_date_label')"
                        name="1"
                    >
                        <el-date-picker
                            v-model="filterData.initialDate"
                            class="mr-2"
                            type="date"
                            :placeholder="translate('rangeInicialDate')"
                            format="dd/MM/yyyy"
                        /><el-date-picker
                            v-model="filterData.endDate"
                            class="mr-2"
                            type="date"
                            :placeholder="translate('rangeFinalDate')"
                            format="dd/MM/yyyy"
                        />
                    </el-collapse-item>

                    <el-collapse-item
                        :title="translate_view_warehouse('operation_type')"
                        name="2"
                    >
                        <el-checkbox-group
                            v-model="filterData.operationTypes"
                            class="dialog-advanced-filter__content__status"
                        >
                            <el-checkbox
                                label="NOTA_FISCAL"
                                v-if="!excludeInvoice"
                            >
                                {{ translate_view_warehouse('invoice') }}
                            </el-checkbox>
                            <el-checkbox label="TRANSFERENCIA_INTERNA">
                                {{
                                    translate_view_warehouse(
                                        'internal_transfer'
                                    )
                                }}
                            </el-checkbox>
                            <el-checkbox label="TRANSFERENCIA_TITULARIDADE">
                                {{
                                    translate_view_warehouse(
                                        'ownership_transfer'
                                    )
                                }}
                            </el-checkbox>
                            <el-checkbox label="EXPORTACAO">
                                {{ translate_view_warehouse('export') }}
                            </el-checkbox>
                            <el-checkbox label="ESTORNO">
                                {{ translate_view_warehouse('reversal') }}
                            </el-checkbox>
                            <el-checkbox label="EMPRESTIMO">
                                {{ translate_view_warehouse('emprestimo_operation')}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-collapse-item>

                    <el-collapse-item
                        :title="translate_view_warehouse('origin_destination')"
                        name="3"
                    >
                        <div class="selectcontainer_origin_destination">
                            <el-select
                                v-model="filterData.origin"
                                :placeholder="
                                    translate_view_warehouse(
                                        'select_origin_warehouse'
                                    )
                                "
                                filterable
                                clearable
                                remote
                                :remote-method="
                                    val => fetchWarehouses(val, 'origin')
                                "
                                :loading="searchingOrigin"
                                :no-data-text="
                                    !searchingOrigin &&
                                    searchingOriginText &&
                                    searchingOriginText.length < 3
                                        ? translate_add_modal(
                                              'type_more_than_three_chars'
                                          )
                                        : translate_add_modal('no_data_text')
                                "
                            >
                                <el-option
                                    v-for="originWarehouse in originWarehouses"
                                    :key="originWarehouse.id"
                                    :label="originWarehouse.unidade"
                                    :value="originWarehouse.id"
                                >
                                    {{ originWarehouse.unidade }}
                                </el-option>
                            </el-select>
                            <el-select
                                v-model="filterData.destination"
                                :placeholder="
                                    translate_view_warehouse(
                                        'select_destination_warehouse'
                                    )
                                "
                                filterable
                                clearable
                                remote
                                :remote-method="
                                    val => fetchWarehouses(val, 'destination')
                                "
                                :loading="searchingDestination"
                                :no-data-text="
                                    !searchingDestination &&
                                    searchingDestinationText &&
                                    searchingDestinationText.length < 3
                                        ? translate_add_modal(
                                              'type_more_than_three_chars'
                                          )
                                        : translate_add_modal('no_data_text')
                                "
                            >
                                <el-option
                                    v-for="destinationWarehouse in destinationWarehouses"
                                    :key="destinationWarehouse.id"
                                    :label="destinationWarehouse.unidade"
                                    :value="destinationWarehouse.id"
                                >
                                    {{ destinationWarehouse.unidade }}
                                </el-option>
                            </el-select>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </el-form>
        </div>
    </div>
</template>

<script>
import ArmazemModuleService from '@/services/ArmazemModuleService';

export default {
    name: 'dialog-advanced-filters',
    props: {
        show: {
            type: Boolean,
            required: true,
            default: () => false
        },
        excludeInvoice: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            collapseSelected: ['1'],
            originWarehouses: [],
            destinationWarehouses: [],
            searchingOrigin: false,
            searchingOriginText: null,
            searchingDestination: false,
            searchingDestinationText: null,
            filterData: {
                origin: null,
                destination: null,
                initialDate: null,
                endDate: null,
                operationTypes: [],
                numeroDocumento: null
            }
        };
    },
    computed: {
        hasFilters() {
            return (
                this.filterData.initialDate ||
                this.filterData.endDate ||
                this.filterData.origin ||
                this.filterData.destination ||
                this.filterData.operationTypes.length > 0 ||
                this.filterData.numeroDocumento
            );
        }
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse.messages.main_filter';
            return this.$tc(`${base}.${key}`, params);
        },
        translate_view_warehouse(key, params = {}) {
            const base = 'warehouse.messages.view_warehouse_filter';
            return this.$tc(`${base}.${key}`, params);
        },
        translate_table(key, params = {}) {
            const base = 'warehouse.table';
            return this.$tc(`${base}.${key}`, params);
        },
        translate_add_modal(key, params = {}) {
            const base = 'warehouse.add_modal';
            return this.$tc(`${base}.${key}`, params);
        },
        clearFilters() {
            this.filterData.initialDate = null;
            this.filterData.endDate = null;
            this.filterData.operationTypes = [];
            this.filterData.origin = null;
            this.filterData.destination = null;
            this.filterData.numeroDocumento = null;
            this.$emit('clear');
        },
        async fetchWarehouses(query, type) {
            if (type === 'origin') {
                this.searchingOriginText = query;
                this.searchingOrigin = true;
            } else {
                this.searchingDestinationText = query;
                this.searchingDestination = true;
            }
            if (query && query.length >= 3) {
                try {
                    const { data } =
                        await ArmazemModuleService.getWarehousesByName(query);
                    if (type === 'origin') {
                        this.originWarehouses = data;
                    } else {
                        this.destinationWarehouses = data;
                    }
                } catch (error) {
                    this.$notify.error({
                        message: this.translate_view_warehouse(
                            'error_fetching_origin_warwhouse'
                        )
                    });
                } finally {
                    if (type === 'origin') {
                        this.searchingOrigin = false;
                    } else {
                        this.searchingDestination = false;
                    }
                }
            } else {
                if (type === 'origin') {
                    this.originWarehouses = [];
                    this.searchingOrigin = false;
                } else {
                    this.destinationWarehouses = [];
                    this.searchingDestination = false;
                }
            }
        }
    }
};
</script>

<style scoped lang="scss">
.dialog-advanced-filter {
    width: 100%;

    .dialog-advanced-filter__header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .dialog-advanced-filter__title {
            font-weight: 500;
            font-size: 16px;
            color: #00413c;
        }

        .dialog-advanced-filter__action {
            display: flex;
            gap: 16px;

            .el-link:first-child {
                color: #e35e58;
                font-size: 14px;
                font-weight: 400;
            }

            .el-link:last-child {
                color: #036be4;
                font-size: 14px;
                font-weight: 400;
            }
        }
    }

    .dialog-advanced-filter__content {
        .dialog-advanced-filter__content__status {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 8px 16px;
        }
    }
}
.selectcontainer_origin_destination {
    display: flex;
    gap: 16px;
    .el-select {
        width: 100%;
    }
}
</style>
